import { memo, useCallback, useContext } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { Button } from 'foundations-components/transitional/components/Button';
import I18n from 'I18n';
import { useControlsStatus } from '../../hooks/_internal/useShouldDisableControls';
import { SeekBackward15Icon } from 'foundations-assets/icons/components/SeekBackward15Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const RewindBtn = /*#__PURE__*/memo(props => {
  const {
    rewind
  } = useContext(MediaPlaybackControlsContext);
  const {
    onRewindCallback
  } = props;
  const handleRewindClick = useCallback(() => {
    rewind(15);
    if (onRewindCallback) {
      onRewindCallback();
    }
  }, [onRewindCallback, rewind]);
  const {
    isDisabled,
    isError,
    isLoaded
  } = useControlsStatus();
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "mediaPlayerControls-rewindButton",
      onClick: handleRewindClick,
      use: "unstyled",
      disabled: isDisabled,
      "aria-label": I18n.text('recordingReviewComponents.media.mediaPlayer.ariaLabels.rewind15'),
      children: /*#__PURE__*/_jsx(SeekBackward15Icon, {
        color: isLoaded && !isError ? 'fill-accent-neutral-default' : 'fill-primary-disabled',
        size: "700"
      })
    })
  });
});
export default RewindBtn;